// extracted by mini-css-extract-plugin
module.exports = {"tplSelectorWrapper":"TplSelector_tplSelectorWrapper__2mw1-"};